import { render, staticRenderFns } from "./bo-product-list.vue?vue&type=template&id=27a8143a"
import script from "./bo-product-list.vue?vue&type=script&lang=js"
export * from "./bo-product-list.vue?vue&type=script&lang=js"
import style0 from "./bo-product-list.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports